import React from "react";
import { LuigisBoxProvider } from "./../Providers/LuigisBoxProvider";
import { Routes } from './../Core/Constants';

function extractAutocompleteTerm(url) {
  try {
    return new URL(url, window.location.origin).searchParams.get("q") ?? "";
  } catch (e) {
    return "";
  }
}

function reportAutocompleteResults(url, rawBody) {
  try {
    const data = JSON.parse(rawBody);
    const hits = data?.hits ?? [];
    const term = extractAutocompleteTerm(url);

    const categories = hits
      .filter(h => h.type === "category")
      .map(h => ({
        id: h.url,
        title: h.attributes?.["title.untouched"] ?? h.attributes?.title
      }));

    const products = hits
      .filter(h => h.type === "item")
      .map(h => ({
        code: h.attributes?.product_code?.[0],
        id: h.attributes?.eshop_id?.[0],
        name: h.attributes?.["title.untouched"] ?? h.attributes?.title,
        price: h.attributes?.price
      }));

    LuigisBoxProvider.sendAutocomplete(term, categories, products);
  } catch (e) {
    console.error("Nepodařilo se zpracovat odpověď Luigi's Box autocomplete pro analytics", e);
  }
}

function isAutocompleteRequest(url) {
  return typeof url === "string" && url.indexOf("/autocomplete/") !== -1;
}

// Autocomplete.js si posílá vlastní analytics (event "luigisbox"), ale ne GA4 styl "view_item_list",
// který potřebujeme do dataLayeru — proto odposloucháváme jeho síťový request a stavíme si event sami.
function patchAutocompleteNetworkTracking() {
  if (window.__lbAutocompleteAnalyticsPatched) {
    return;
  }
  window.__lbAutocompleteAnalyticsPatched = true;

  const originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      const url = typeof input === "string" ? input : input?.url;
      const promise = originalFetch.apply(this, arguments);
      if (isAutocompleteRequest(url)) {
        promise.then(response => {
          response.clone().text().then(body => reportAutocompleteResults(url, body)).catch(() => {});
        }).catch(() => {});
      }
      return promise;
    };
  }

  const OriginalXHR = window.XMLHttpRequest;
  const originalOpen = OriginalXHR.prototype.open;
  OriginalXHR.prototype.open = function (method, url) {
    this.__lbAutocompleteUrl = url;
    return originalOpen.apply(this, arguments);
  };
  const originalSend = OriginalXHR.prototype.send;
  OriginalXHR.prototype.send = function () {
    if (isAutocompleteRequest(this.__lbAutocompleteUrl)) {
      this.addEventListener("load", () => {
        reportAutocompleteResults(this.__lbAutocompleteUrl, this.responseText);
      });
    }
    return originalSend.apply(this, arguments);
  };
}

export default class LuigiAutocomplete extends React.Component {


  componentDidMount() {
    if (!this.props.enabled){
         return;
    }

    patchAutocompleteNetworkTracking();

    if (window.AutoComplete) {
      this.initAutocomplete();
      return;
    }

    const script = document.createElement("script");
    script.id = "lbx-autocomplete-js";
    script.src = "https://cdn.luigisbox.tech/autocomplete.js";
    script.async = true;
    script.onload = () => this.initAutocomplete();
    script.onerror = () => console.error("Nepodařilo se načíst Luigi's Box autocomplete.js");
    document.body.appendChild(script);
  }


getLocaleByLangId() {
  switch (this.props.langId) {
    case "0": // Czech
    case "7": // Czech2
      return "cs";

    case "1": // Slovak
      return "sk";

    case "2": // Hungarian
      return "hu";

    case "3": // Ukrainian
      return "uk";

    case "4": // Russian
      return "ru";

    case "5": // German
      return "de";

    case "6": // English
      return "en";

    case "8": // Polish
      return "pl";

    default:
      return "cs"; 
  }
}

  

  initAutocomplete() {
    const input = document.querySelector("#searchphrase");
    if (!input) {
      console.error("Není input #searchphrase");
      return;
    }
    if (!window.AutoComplete) return;

    window.AutoComplete(
      {
        Layout: "heromobile",
        TrackerId: this.props.luigiTrackerId,
        Locale: this.getLocaleByLangId(),
        Types: [
        { 
            type: "item", 
            context: "",
            placement: "",
            name: "",
            size: 7,
            attributes: ["availability_rank_text.hl"],
            recommend: {size: "7"},
            defaultFilters: null,
            position: 1,
            disabled: false,
            phrases: false
        },
        {
            type: "category",
            context: "",
            placement: "",
            name: "",
            size: 5,
            attributes: [],
            recommend: {
                size: "5"
            },
            defaultFilters: null,
            position: 2,
            disabled: false,
            phrases: false
            },

        /*
        {
            size: 7,
            type: "query",
            placement: "",
            attributes: [],
            position: 3,
            recommend: {
                size: 7
            }
        }
        */
            ],
            ShowAllCallback(event) {
                if (event && typeof event.preventDefault === "function") {
                    event.preventDefault();
                }
                var query = document.querySelector("#searchphrase").value || "";
                window.location.href = Routes.Search + '?q=' + encodeURIComponent(query || '');
            },
      },
      "#searchphrase",
      document
    );
  }

  render() {
    return null; // žádný extra input
  }
}
